// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* styles.module.css */
.styles_container__UAWNh {
  margin: 0 2rem;
  padding: 0;
  border-radius: 12px !important;
  background-color: #f5f7fa;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0,0,0,0.10);
}

.styles_header__vt3uF {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: space-between;
  padding: 16px 24px;
  background-color: #ffffff;
  border-bottom: 1px solid #e0e0e0;
}

.styles_title__F-SkC {
  align-items: center;
  color: #424242;
  display: flex;
  flex: 1 1;
  font-family: "Abhaya Libre";
  font-size: 2rem;
  font-weight: 600;
  gap: 12px;
}

.styles_filtrosContainer__I2wAm {
  align-items: center;
  display: flex;
  flex-direction: row;
  background-color: #ffffff;
}

.styles_filtrosContainerFullWidth__enHkK {
  border-top: 1px solid #e0e0e0;
  margin: 8px -24px 0;
  padding: 22px 24px 4px;
}

.styles_iconFilter__RHnN1 {
  color: #18316e;
  font-size: 2rem;
  margin-right: 0.5rem;
}

.styles_tipoVisualizacaoContainer__F3Hqs {
  display: flex;
  justify-content: flex-end;
  margin: 1rem 0;
}

.styles_iconVisualizacoes__UQ3st {
  color: #18316e !important;
  font-size: 2.3rem !important;
  margin-left: 0.5rem !important;
  padding: 0.5rem !important;
}

.styles_iconVisualizacoes__UQ3st:hover {
  background-color: #bebebe !important;
  border-radius: 50% !important;
  color: white !important;
  cursor: pointer !important;
  padding: 0.5rem !important;
}

.styles_iconVisualizacoesActive__3YWY7 {
  background-color: #919191 !important;
  border-radius: 50% !important;
  color: white !important;
  cursor: pointer !important;
  font-size: 2.3rem !important;
  margin-left: 0.5rem !important;
  padding: 0.5rem !important;
}

/* Área dos cards de stats — fundo igual ao thead da tabela */
.styles_contentAboveTable__jfG3G {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  width: 100%;
  background-color: #fafafa;
  padding: 20px 24px;
}

.styles_contentAboveTableGrid4__XaVPk {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
  width: 100%;
  background-color: #fafafa;
  padding: 20px 24px;
}

@media (max-width: 768px) {
  .styles_contentAboveTableGrid4__XaVPk {
    grid-template-columns: repeat(2, 1fr);
  }
}

.styles_alignTablePadding__PDWP\\+ {
  padding-left: 24px;
  padding-right: 24px;
  margin-top: 0;
}

/* Card interno único: header + stats + tabela */
.styles_innerCard__qn3AI {
  margin: 16px 24px 16px 24px;
  border-radius: 12px !important;
  border: 1px solid #e0e0e0;
  background-color: #ffffff;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0,0,0,0.07);
}

/* Linha separadora de borda a borda entre stats e tabela */
.styles_tableDivider__y4s9E {
  width: 100%;
  height: 1px;
  background-color: #e0e0e0;
}

.styles_visualizacaoContainer__ea2CF {
  margin-top: 0;
  overflow: auto;
  padding: 0;
  background-color: #ffffff;
}

/* Opt-in via ApuracaoCardShell (prop conteudoComScrollProprio) — usado quando a tabela lá
 * dentro já rola horizontalmente sozinha (wrapper com borda própria + overflow:auto). Sem
 * isso, essa div E a tabela rolavam ao mesmo tempo, dando duas barras de rolagem pra rolar
 * a mesma coisa. Só desliga a rolagem HORIZONTAL desta div — quem não passar a prop nem
 * carrega esta classe, então nenhum outro consumidor do ApuracaoCardShell muda. */
.styles_visualizacaoContainerSemScrollProprio__Un9sa {
  overflow-x: visible;
}

.styles_headerButtons__DucqV {
  align-items: center;
  display: flex;
  gap: 5px;
}

.styles_headerCampos__K-f83 {
  align-items: center;
  display: flex;
  gap: 15px;
  justify-content: center;
}

.styles_inputs_header__Fx5RS {
  align-items: flex-start;
  display: flex;
  gap: 0.5rem;
}

@media (max-width: 780px) {
  .styles_container__UAWNh {
    margin: 0 1rem;
  }

  .styles_title__F-SkC {
    align-self: flex-start;
  }

  .styles_filtrosContainer__I2wAm {
    flex-direction: column;
    margin-bottom: 8px;
    width: 100%;
  }

  .styles_headerButtons__DucqV {
    flex-direction: column;
  }

  .styles_headerCampos__K-f83 {
    flex-direction: column;
  }

  .styles_header__vt3uF {
    flex-direction: column;
  }
}

@media (max-width: 900px) {
  .styles_inputs_header__Fx5RS {
    flex-direction: column;
  }
}

.styles_iconeAdd__lZX1l {
  color: #fff;
  font-size: 2rem;
}

.styles_iconeAdd__lZX1l:hover {
  color: #18316e;
}`, "",{"version":3,"sources":["webpack://./src/components/TableCard/styles.module.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,cAAc;EACd,UAAU;EACV,8BAA8B;EAC9B,yBAAyB;EACzB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,SAAS;EACT,8BAA8B;EAC9B,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,SAAO;EACP,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,uBAAuB;EACvB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,uBAAuB;EACvB,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;AACf;;AAEA,gDAAgD;AAChD;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA,2DAA2D;AAC3D;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,UAAU;EACV,yBAAyB;AAC3B;;AAEA;;;;kFAIkF;AAClF;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,WAAW;AACb;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* styles.module.css */\n.container {\n  margin: 0 2rem;\n  padding: 0;\n  border-radius: 12px !important;\n  background-color: #f5f7fa;\n  overflow: hidden;\n  box-shadow: 0 1px 4px rgba(0,0,0,0.10);\n}\n\n.header {\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  justify-content: space-between;\n  padding: 16px 24px;\n  background-color: #ffffff;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.title {\n  align-items: center;\n  color: #424242;\n  display: flex;\n  flex: 1;\n  font-family: \"Abhaya Libre\";\n  font-size: 2rem;\n  font-weight: 600;\n  gap: 12px;\n}\n\n.filtrosContainer {\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  background-color: #ffffff;\n}\n\n.filtrosContainerFullWidth {\n  border-top: 1px solid #e0e0e0;\n  margin: 8px -24px 0;\n  padding: 22px 24px 4px;\n}\n\n.iconFilter {\n  color: #18316e;\n  font-size: 2rem;\n  margin-right: 0.5rem;\n}\n\n.tipoVisualizacaoContainer {\n  display: flex;\n  justify-content: flex-end;\n  margin: 1rem 0;\n}\n\n.iconVisualizacoes {\n  color: #18316e !important;\n  font-size: 2.3rem !important;\n  margin-left: 0.5rem !important;\n  padding: 0.5rem !important;\n}\n\n.iconVisualizacoes:hover {\n  background-color: #bebebe !important;\n  border-radius: 50% !important;\n  color: white !important;\n  cursor: pointer !important;\n  padding: 0.5rem !important;\n}\n\n.iconVisualizacoesActive {\n  background-color: #919191 !important;\n  border-radius: 50% !important;\n  color: white !important;\n  cursor: pointer !important;\n  font-size: 2.3rem !important;\n  margin-left: 0.5rem !important;\n  padding: 0.5rem !important;\n}\n\n/* Área dos cards de stats — fundo igual ao thead da tabela */\n.contentAboveTable {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  width: 100%;\n  background-color: #fafafa;\n  padding: 20px 24px;\n}\n\n.contentAboveTableGrid4 {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 1rem;\n  width: 100%;\n  background-color: #fafafa;\n  padding: 20px 24px;\n}\n\n@media (max-width: 768px) {\n  .contentAboveTableGrid4 {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n.alignTablePadding {\n  padding-left: 24px;\n  padding-right: 24px;\n  margin-top: 0;\n}\n\n/* Card interno único: header + stats + tabela */\n.innerCard {\n  margin: 16px 24px 16px 24px;\n  border-radius: 12px !important;\n  border: 1px solid #e0e0e0;\n  background-color: #ffffff;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.07);\n}\n\n/* Linha separadora de borda a borda entre stats e tabela */\n.tableDivider {\n  width: 100%;\n  height: 1px;\n  background-color: #e0e0e0;\n}\n\n.visualizacaoContainer {\n  margin-top: 0;\n  overflow: auto;\n  padding: 0;\n  background-color: #ffffff;\n}\n\n/* Opt-in via ApuracaoCardShell (prop conteudoComScrollProprio) — usado quando a tabela lá\n * dentro já rola horizontalmente sozinha (wrapper com borda própria + overflow:auto). Sem\n * isso, essa div E a tabela rolavam ao mesmo tempo, dando duas barras de rolagem pra rolar\n * a mesma coisa. Só desliga a rolagem HORIZONTAL desta div — quem não passar a prop nem\n * carrega esta classe, então nenhum outro consumidor do ApuracaoCardShell muda. */\n.visualizacaoContainerSemScrollProprio {\n  overflow-x: visible;\n}\n\n.headerButtons {\n  align-items: center;\n  display: flex;\n  gap: 5px;\n}\n\n.headerCampos {\n  align-items: center;\n  display: flex;\n  gap: 15px;\n  justify-content: center;\n}\n\n.inputs_header {\n  align-items: flex-start;\n  display: flex;\n  gap: 0.5rem;\n}\n\n@media (max-width: 780px) {\n  .container {\n    margin: 0 1rem;\n  }\n\n  .title {\n    align-self: flex-start;\n  }\n\n  .filtrosContainer {\n    flex-direction: column;\n    margin-bottom: 8px;\n    width: 100%;\n  }\n\n  .headerButtons {\n    flex-direction: column;\n  }\n\n  .headerCampos {\n    flex-direction: column;\n  }\n\n  .header {\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 900px) {\n  .inputs_header {\n    flex-direction: column;\n  }\n}\n\n.iconeAdd {\n  color: #fff;\n  font-size: 2rem;\n}\n\n.iconeAdd:hover {\n  color: #18316e;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__UAWNh`,
	"header": `styles_header__vt3uF`,
	"title": `styles_title__F-SkC`,
	"filtrosContainer": `styles_filtrosContainer__I2wAm`,
	"filtrosContainerFullWidth": `styles_filtrosContainerFullWidth__enHkK`,
	"iconFilter": `styles_iconFilter__RHnN1`,
	"tipoVisualizacaoContainer": `styles_tipoVisualizacaoContainer__F3Hqs`,
	"iconVisualizacoes": `styles_iconVisualizacoes__UQ3st`,
	"iconVisualizacoesActive": `styles_iconVisualizacoesActive__3YWY7`,
	"contentAboveTable": `styles_contentAboveTable__jfG3G`,
	"contentAboveTableGrid4": `styles_contentAboveTableGrid4__XaVPk`,
	"alignTablePadding": `styles_alignTablePadding__PDWP+`,
	"innerCard": `styles_innerCard__qn3AI`,
	"tableDivider": `styles_tableDivider__y4s9E`,
	"visualizacaoContainer": `styles_visualizacaoContainer__ea2CF`,
	"visualizacaoContainerSemScrollProprio": `styles_visualizacaoContainerSemScrollProprio__Un9sa`,
	"headerButtons": `styles_headerButtons__DucqV`,
	"headerCampos": `styles_headerCampos__K-f83`,
	"inputs_header": `styles_inputs_header__Fx5RS`,
	"iconeAdd": `styles_iconeAdd__lZX1l`
};
export default ___CSS_LOADER_EXPORT___;
